/* Polyfill indexOf. */
var indexOf;

if (typeof Array.prototype.indexOf === 'function') {
  indexOf = function (haystack, needle) {
    return haystack.indexOf(needle);
  };
} else {
  indexOf = function (haystack, needle) {
    var i = 0, length = haystack.length, idx = -1, found = false;

    while (i < length && !found) {
      if (haystack[i] === needle) {
        idx = i;
        found = true;
      }

      i++;
    }

    return idx;
  };
};


/**
 * Polyfill for EventEmitter
 * @example
 * class Foo extends EventEmitter {
 *  function testEmit() {
 *    this.emit('awesome-event', { greeting: 'Hello', name: 'Tobias'})
 *  }
 * }
 *  
 * const foo = new Foo();
 * foo.on('awesome-event', eventData => {
 *   console.log(`${eventData.greeting} ${eventData.name}!`)
 * })
 * 
 * @class
 */
var EventEmitter = function () {
  this.events = {};
};

/**
 * Register a **listener** for a certain (custom) **event**. Note: Do not use anonymous functions when you need to `removeListener` afterwards.
 * @param {string} event Name of the custom event
 * @param {function} listener Callback listener function
 */
EventEmitter.prototype.on = function (event, listener) {
  if (typeof this.events[event] !== 'object') {
    this.events[event] = [];
  }

  this.events[event].push(listener);
};

/**
 * Remove a listener that was registered before, note that the function reference must be identical.
 * @param {string} event Name of the custom event
 * @param {function} listener Reference to listener function
 */
EventEmitter.prototype.removeListener = function (event, listener) {
  var idx;

  if (typeof this.events[event] === 'object') {
    idx = indexOf(this.events[event], listener);

    if (idx > -1) {
      this.events[event].splice(idx, 1);
    }
  }
};

/**
 * Emit a custom event that is dispatched to all registered listeners.
 * @param {string} event Name of the emitted event
 * @param {...object} args All arguments that are dispatched to the listener
 */
EventEmitter.prototype.emit = function (event) {
  var i, listeners, length, args = [].slice.call(arguments, 1);

  if (typeof this.events[event] === 'object') {
    listeners = this.events[event].slice();
    length = listeners.length;

    for (i = 0; i < length; i++) {
      listeners[i].apply(this, args);
    }
  }
};

/**
 * Register a event listener that is only called once and then immediately deregistered.
 * @param {string} event The name of the custom event
 * @param {*} listener The listener function
 */
EventEmitter.prototype.once = function (event, listener) {
  this.on(event, function g() {
    this.removeListener(event, g);
    listener.apply(this, arguments);
  });
};

export { EventEmitter };